import React, { useEffect, useState } from "react";
import { Box, Paper, Tabs, Tab, Typography, Container } from "@mui/material";
import {
  LocalOffer as OfferIcon,
  Percent as CommissionIcon,
  Description as DocumentsIcon,
  ToggleOn as StatusIcon,
  Handshake,
  Info,
  Discount,
} from "@mui/icons-material";
import { PropertyOfferPage } from "../publish-property-children/PropertyOfferPage";
import { EditCommissionPage } from "../publish-property-children/EditCommissionPage";
import { CollaborationRequestsSection } from "../publish-property-children/CollaborationRequestsSection";
import DocumentsPlaceholder from "../../../components/publishProperty/screen/DocumentsScreen";
import { EditPropertyStatus } from "../publish-property-children/EditPropertyStatus";
import { PropertyListing } from "../../../types/Property";
import PropertyDetails from "../../../components/propertyDetailChildren/PropertyDetails";
import { PropertyCouponPage } from "../publish-property-children/PropertyCouponPage";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`property-edit-tabpanel-${index}`}
      aria-labelledby={`property-edit-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `property-edit-tab-${index}`,
    "aria-controls": `property-edit-tabpanel-${index}`,
  };
}

interface PropertyEditSectionProps {
  property: PropertyListing;
}

const PropertyEditSection: React.FC<PropertyEditSectionProps> = ({
  property,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  /* eslint-disable */
  const [documentValidationErrors, setDocumentValidationErrors] = useState<any>(
      {}
    );
    /* eslint-disable */
    const [showDocumentValidation, setShowDocumentValidation] = useState(false);
    /* eslint-disable */
    const [documentChanges, setDocumentChanges] = useState<any>({});
    const [documentData, setDocumentData] = useState<any>(null);
    const [selectedProperty, setSelectedProperty] = useState<PropertyListing>(property);

    useEffect(() => {
        setSelectedProperty(property);
    }, [property]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleDocumentDataChange = (data: any) => {
    setDocumentChanges(data);
    if (!documentData) {
      setDocumentData(data);
    }
  };
  const tabs = [
    {
      label: "Detalles",
      icon: <Info />,
      content: <PropertyDetails property={property} />,
    },
    {
      label: "Estado",
      icon: <StatusIcon />,
      content: <EditPropertyStatus selectedProperty={selectedProperty} />,
    },
    {
      label: "Oferta",
      icon: <OfferIcon />,
      content: <PropertyOfferPage selectedProperty={selectedProperty} />,
    },
    {
      label: "Cupones",
      icon: <Discount />,
      content: <PropertyCouponPage property={selectedProperty} />,
    },
    {
      label: "Comisión",
      icon: <CommissionIcon />,
      content: <EditCommissionPage selectedProperty={selectedProperty} />,
    },
    {
      label: "Solicitudes de comisión",
      icon: <Handshake />,
      content: <CollaborationRequestsSection selectedProperty={selectedProperty} />,
    },
    {
      label: "Documentos y dueños",
      icon: <DocumentsIcon />,
      content: (
        <DocumentsPlaceholder
          propertyId={selectedProperty?.id_Property}
          onDataChange={handleDocumentDataChange}
          validationErrors={documentValidationErrors}
          showValidation={showDocumentValidation}
        />
      ),
    },
  ];

  return (
    <Container maxWidth={false} sx={{ px: 0, mb: 4 }}>
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          overflow: "auto",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              "& .MuiTab-root": {
                minHeight: 72,
                textTransform: "none",
                fontWeight: 500,
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                icon={tab.icon}
                label={tab.label}
                iconPosition="start"
                {...a11yProps(index)}
                sx={{
                  "& .MuiTab-iconWrapper": {
                    marginRight: 1,
                    marginBottom: 0,
                  },
                }}
              />
            ))}
          </Tabs>

          {tabs.map((tab, index) => (
            <TabPanel key={index} value={activeTab} index={index}>
              <Box
                sx={{
                  minHeight: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 2,
                }}
              >
                <Typography variant="body1" color="text.secondary">
                  {tab.content}
                </Typography>
              </Box>
            </TabPanel>
          ))}
        </Box>
      </Paper>
    </Container>
  );
};

export default PropertyEditSection;
